// extracted by mini-css-extract-plugin
export default {"btn":"RemoveButton_btn__I0-D9"};